import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import MenuWarehouseDepartmentEdit from './MenuWarehouseDepartmentEdit';

export default function MenuWarehouseDepartment(props: any) {

    //表头
    const columnsHead = [
        {
            title: '出品部门',
            dataIndex: 'menuWarehouseDepartmentName',
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];
    
    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '出品部门',
        apiId: 'menuWarehouseDepartment',
        showStates: true,
        columns,
        pagination: true,
        EditComponent: MenuWarehouseDepartmentEdit,
    };

    return (
        <WebUniversalNewEx props={extendProps}></WebUniversalNewEx>
    )
}